import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import LoginPage from 'pages/LoginPage';
import RegistrationPage from '../pages/RegistrationPage';
import { PrivateRoutesCompanyId, PrivateRoutesToken } from 'common/components/PrivateRoutes';
import SettingsOutlet from 'pages/Settings/components/SettingsOutlet';
import UsersAndRolesPage from 'pages/Settings/UsersAndRoles';
import ContactsPage from 'pages/ContactsPage';
import BaseLayout from 'common/components/BaseLayout';
import AddUserPage from 'pages/AddUserPage';
import ServicesPage from 'pages/ServicesPage';
import UserPage from 'pages/UserPage';
import CreateOrderPage from 'pages/CreateOrderPage';
import UserPageOutlet from 'pages/UserPage/components/UserPageOutlet';
import UserFinancesPage from 'pages/UserPage/pages/UserFinancesPage';
import UserStatisticsPage from 'pages/UserPage/pages/UserStatisticsPage';
import CollaborationsOutlet from 'pages/Collaborations/Outlet';
import ChatPage from 'pages/Collaborations/ChatPage';
import ChatNotSelected from 'pages/Collaborations/ChatPage/components/NotSelected';
import ChatContent from 'pages/Collaborations/ChatPage/components/ChatContent';
import MailPage from 'pages/Collaborations/MailPage';
import CalendarPage from 'pages/Collaborations/CalendarPage';
import AccountSettingsPage from 'pages/Settings/AccountSettingsPage';
import PlannerPage from 'pages/Collaborations/PlannerPage';
import Board from 'pages/Collaborations/PlannerPage/components/Board';
import RemindersPage from 'pages/Collaborations/RemindersPage';
import DashboardPage from 'pages/DashboardPage';
import OrderCardPage from 'pages/OrderCardPage';
import DashboardManager from 'pages/DashboardPage/pages/DashboardManager';
import DashboardEmployee from 'pages/DashboardPage/pages/DashboardEmployee';
import DashboardHeadOfDepartment from 'pages/DashboardPage/pages/DashboardHeadOfDepartment';
import AccountPage, { AccountPosts } from 'pages/AccountPage';
import GalleryPage from 'pages/AccountPage/pages/GalleryPage';
import EventsPage from 'pages/AccountPage/pages/EventsPage';
import VacanciesPage from 'pages/AccountPage/pages/VacanciesPage';
import InfoPage from 'pages/AccountPage/pages/InfoPage';
import FilesPage from 'pages/FilesPage';
import ApplicationsPage from 'pages/ApplicationsPage';



export default function WorkspaceRouter({ isLightTheme, setThemePicked }: { isLightTheme:boolean; setThemePicked: React.Dispatch<React.SetStateAction<boolean>> }) {
  return (
		<BrowserRouter>
			<Routes>
				<Route element={<BaseLayout isLightTheme={isLightTheme} setThemePicked={setThemePicked} />}>
					<Route path="/" element={<HomePage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route element={<PrivateRoutesToken />}>
						<Route element={<RegistrationPage />} path='/registration' />
						<Route element={<PrivateRoutesCompanyId />}>
							<Route element={<AccountPage />} path='/:id'>
								<Route element={<AccountPosts />} index />
								<Route element={<div>Services</div> } path='services' />
								<Route element={<div>Reviews</div> } path='reviews' />
								<Route element={<EventsPage /> } path='events' />
								<Route element={<GalleryPage /> } path='gallery' />
								<Route element={<div>services</div> } path='services' />
								<Route element={<div>reminders</div> } path='reminders' />
								<Route element={<VacanciesPage /> } path='vacancies' />
								<Route element={<InfoPage /> } path='info' />
								<Route element={<Navigate to='' />} path='*' />
							</Route>
							<Route element={<SettingsOutlet />} path='/settings'>
								<Route element={<AccountSettingsPage />} index></Route>
								<Route element={<UsersAndRolesPage />} path='users_and_roles' />
							</Route>
							<Route element={<ContactsPage />} path='/contacts' />
							<Route element={<AddUserPage />} path='/contacts/add_client' />
							<Route element={<UserPageOutlet />} path='/contacts/:id'>
								<Route element={<UserPage />} index />
								<Route element={<UserFinancesPage />} path='finances' />
								<Route element={<UserStatisticsPage />} path='statistics' />
							</Route>
							<Route element={<ServicesPage />} path='/services' />
							<Route path='/services/orders/:id' element={<OrderCardPage />} />
							<Route element={<CreateOrderPage />} path='/services/orders/create' />
							<Route element={<CollaborationsOutlet />} path='/collaborations' >
								<Route element={<ChatPage />} path='chat'>
									<Route element={<ChatNotSelected/>} index />
									<Route element={<ChatContent/>} path=':chatId' />
								</Route>
								<Route element={<MailPage />} path='mail' />
								<Route element={<CalendarPage />} path='calendar' />
								<Route element={<PlannerPage />} path='planner'>
									<Route element={<Board/>} path=':boardId' />
								</Route>
								<Route element={<div>Notes</div>} path='notes' />
								<Route element={<RemindersPage />} path='reminders' />
								<Route index element={<Navigate to='chat' replace />} />
							</Route>
							<Route element={<DashboardPage />} path='/dashboard'>
								<Route element={<DashboardManager />} path='manager' />
								<Route element={<DashboardEmployee />} path='employee' />
								<Route element={<DashboardHeadOfDepartment />} path='head_of_department' />
								<Route index element={<Navigate to='head_of_department' replace />} />
							</Route>
							<Route element={<FilesPage />} path='/files' />
							<Route element={<ApplicationsPage />} path='/applications' />
						</Route>
					</Route>
				</Route>
			</Routes>
		</BrowserRouter>
  );
}